import ReactDOM from "react-dom";
import Slider from "react-slick";

import './RowList.scss'

import CardMovies from "../Cards/CardMovies";
import CardChannels from "../Cards/CardChannels";
import { useRouter } from "../../hooks/router";
import { useState } from "react";
import PremiumField from "../pages_child/PremiumField/PremiumField";
import Modal from "../Pages/Modal/Modal";
import { translateWord,decrypt } from "../Util/util";
import icon_lock from "../Pages/Player/images/lock_white.png";


export default function RowList({
    title,
    type,
    row,
    array,
    content_type,
    appSettings,
    isGuest
}) {
    const router = useRouter()

    const [showPremium, setShowPremium] = useState({
        show: false,
        id: '',
        type: ''
    })

    const settings_movie = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                }
            },
        ]
    }
    const settings_channels = {

        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: false,
                    dots: false
                }
            },
        ]
    }


    return (
        <>
            {showPremium.show ?

                isGuest ?
                    ReactDOM.createPortal(
                        <Modal
                            btnConfirm={() => {
                                localStorage.setItem('showLogin', true)
                                router.push('/auth')
                            }}
                            btnCancel={() => setShowPremium(false)}
                            btnConfirmText={translateWord('Sign in')}
                            btnCancelText={translateWord('Cancel')}
                            title={translateWord('Sign in to continue')}
                        />, document.body)

                    :

                    ReactDOM.createPortal(<PremiumField id={showPremium.id} type={showPremium.type} close={() => {
                        setShowPremium({
                            show: false,
                            id: '',
                            type: ''
                        })
                        router.push(`/settings?a=payment&content_id=${showPremium.id}`)
                    }
                    } />, document.body)

                : null}
            <div className="parent_row conteiner">
                <h1 className="title_list">
                    {(translateWord(title).indexOf('{{sub_user}}') != -1 ?
                        (translateWord(title).replace('{{sub_user}}', JSON.parse(decrypt('user', localStorage.getItem('user'))).name)) :
                        translateWord(title))}
                    {content_type === 'lessons' && !row.can_watch ?
                        <img src={icon_lock} alt="" />
                        : null}
                </h1>
                <div className="visible_row">
                    {type === 'live_tv' ?
                        <div id="live">
                            <Slider {...settings_channels}>
                                {array.map((card, cardIndex) => {
                                    return <CardChannels
                                        setShowPremium={setShowPremium}
                                        rowLength={array.length}
                                        key={card.id}
                                        cardIndex={cardIndex}
                                        card={card}
                                        isGuest={isGuest}
                                    />
                                })}
                            </Slider>
                        </div>
                        :
                        <div id="movie" className={row.title === "Continue watching" ? 'continue' : ''}>
                            <Slider {...settings_movie}>
                                {array.map((card, cardIndex) => {
                                    return <CardMovies
                                        content_type={content_type}
                                        rowLength={array.length}
                                        key={card.id}
                                        title={title}
                                        cardIndex={cardIndex}
                                        card={card}
                                        row={row}
                                        isGuest={isGuest}

                                    />
                                })}
                            </Slider>
                        </div>

                    }

                </div>
            </div>
        </>

    )
}